import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Stars } from 'components/common/stars';
import Channel from 'components/channel/Channel';
import { closeDrawer } from 'features/drawersSlice';
import {
    toggle as toggleReviewsDrawer,
    getBookingWidgetReviews,
} from 'features/ReviewsSlice';

import { BookButton } from 'components/bookButton';
import { ReadMore } from 'components/common/readMore';
import { stripHTMLTags } from '../../lib';
import './MultipropertyCard.css';
import { MdFreeBreakfast } from 'react-icons/md';

const MultipropertyCard = ({
    property = {},
    Lang = {},
    openPropertyDetails,
}) => {
    const dispatch = useDispatch();

    const { currencySymbol } = useSelector(
        (state) => state.miniBookingWidget?.data?.ourPrice
    );

    return (
        <div className="ab-property-row">
            <div className="ab-bestprice-ribbon-multiproperty">
                {property.ourPrice.text}
            </div>
            <div className="ab-property_list ab-custom-scrollbar">
                <div className="ab-property">
                    <div
                        className="ab-property_image_container"
                        onClick={() =>
                            openPropertyDetails(
                                property?.propertyID,
                                property?.parentPropertyID
                            )
                        }
                    >
                        <div
                            className="ab-property_image"
                            style={{
                                backgroundImage: `url("${property.propertyLogo}")`,
                            }}
                        ></div>
                    </div>
                    <div
                        className="ab-property_body_container"
                        onClick={() =>
                            openPropertyDetails(
                                property?.propertyID,
                                property?.parentPropertyID
                            )
                        }
                    >
                        <div className="ab-body_title">
                            <div className="ab-property_name">
                                {property.propertyName}
                            </div>
                            <div className="ab-stars">
                                <Stars
                                    rating={property.propertyStars}
                                    color={'#000'}
                                />
                            </div>
                        </div>
                        <div
                            className="ab-main_body"
                            style={{
                                marginTop: `auto`,
                            }}
                        >
                            <div className="ab-room-upper-description">
                                <ReadMore
                                    moreText={Lang.more}
                                    lessText={Lang.less}
                                >
                                    {stripHTMLTags(
                                        property.propertyDescription
                                    )}
                                </ReadMore>
                            </div>
                            <div className="ab-scores_wrapper">
                                {property?.totalScore && (
                                    <span
                                        className="ab-score"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            dispatch(
                                                getBookingWidgetReviews({
                                                    reviewsUrl:
                                                        property.commentsUrl,
                                                })
                                            );
                                            dispatch(
                                                closeDrawer({
                                                    drawerId:
                                                        'BigBookingWidgetDrawer',
                                                })
                                            );
                                            dispatch(toggleReviewsDrawer());
                                        }}
                                    >
                                        {property?.totalScore?.split(' /')[0]}
                                    </span>
                                )}

                                <div
                                    style={{
                                        display: 'inline-block',
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            gridTemplateColumns: '1fr 1fr',
                                            gap: '20px',
                                        }}
                                    >
                                        {property?.totalScore && (
                                            <div>
                                                <div className="ab-grades">
                                                    {property.scoreRating}
                                                </div>
                                                <div className="ab-reviews">
                                                    {property.totalReviews}
                                                </div>
                                            </div>
                                        )}

                                        <div>
                                            <div className="ab-grades">
                                                {Lang?.location ?? 'location'}
                                            </div>
                                            <div className="ab-reviews">
                                                {property.ariaLocation}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="ab-property_footer">
                                {property.channels.length > 0 && (
                                    <div className="ab-desktop-widget-channels">
                                        {property.channels.map(
                                            (channel, index) => {
                                                let styles = {};
                                                if (index >= 3) {
                                                    styles = {
                                                        marginTop: '7px',
                                                    };
                                                }
                                                return (
                                                    <Channel
                                                        logo={channel?.logo}
                                                        name={channel?.name}
                                                        currencySymbol={
                                                            channel?.currencySymbol
                                                        }
                                                        price={channel?.price}
                                                        key={`${property?.propertyID}-${channel?.channelID}`}
                                                        extraClasses={[
                                                            'ab-channel--desktop ab-channel--multiproperty',
                                                        ]}
                                                        styles={{
                                                            ...styles,
                                                        }}
                                                        logoSize={15}
                                                        channelId={
                                                            channel?.channelID
                                                        }
                                                        isMultiproperty={true}
                                                    />
                                                );
                                            }
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="ab-property-right-container">
                        <div className="ab-property-price-section">
                            {property.ourPrice?.loyaltyprice &&
                            property.ourPrice?.loyaltyprice !== '0' ? (
                                <>
                                    <div className="ab-old-price">
                                        {property.ourPrice?.price}{' '}
                                        {property.lowestPrice > 0 &&
                                            currencySymbol}
                                    </div>
                                    <div
                                        className="ab-price"
                                        tabIndex="0"
                                        role="button"
                                    >
                                        {property.ourPrice?.loyaltyprice}{' '}
                                        {property.lowestPrice > 0 &&
                                            currencySymbol}
                                    </div>
                                    <div className="ab-providerWrap">
                                        <div className="ab-provider">
                                            {Lang?.saveText}{' '}
                                            <span className="ab-discount">
                                                {property.ourPrice?.discount}{' '}
                                                {property.lowestPrice > 0 &&
                                                    currencySymbol}
                                            </span>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                property.ourPrice?.price &&
                                property.ourPrice?.price !== '0' && (
                                    <>
                                        <div
                                            className="ab-price"
                                            tabIndex="0"
                                            role="button"
                                        >
                                            {property.ourPrice?.price}{' '}
                                            {property.lowestPrice > 0 &&
                                                currencySymbol}
                                        </div>
                                    </>
                                )
                            )}

                            {property.lowestPrice > 0 && (
                                <>
                                    {property.ourPrice?.hasMinStay && (
                                        <div className="ab-room-upper-minstay">
                                            Min-Stay
                                        </div>
                                    )}
                                    <div className="ab-freebies">
                                        <div className="ab-freebie">
                                            {
                                                property?.ourPrice
                                                    ?.cancelationPolicyType
                                            }
                                        </div>
                                    </div>
                                    {property.ourPrice?.hasBreakfast ? (
                                        <>
                                            <div className="ab-freebies">
                                                <div className="ab-freebie">
                                                    <MdFreeBreakfast
                                                        size={20}
                                                    />
                                                    <span className="ab-breakfast-text">
                                                        {Lang?.breakfastText}
                                                    </span>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </>
                            )}
                        </div>

                        <BookButton
                            currencySymbol={currencySymbol}
                            price={
                                property.lowestPrice > 0
                                    ? property?.ourPrice?.price
                                    : ''
                            }
                            text={
                                property.lowestPrice > 0
                                    ? Lang?.bookNowText
                                    : Lang?.soldOut
                            }
                            url={property?.ourPrice?.bigPluginUrl}
                            variant="non-member"
                            noPrice={!property.lowestPrice}
                            className={
                                !property.lowestPrice &&
                                'ab-book-button-sold-out'
                            }
                        />
                        <BookButton
                            currencySymbol={currencySymbol}
                            price={property?.ourPrice?.loyaltyprice}
                            text={Lang?.signIn}
                            url={property?.ourPrice?.loyaltyBigPluginUrl}
                            variant="member"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

MultipropertyCard.propTypes = {
    property: PropTypes.object,
    Lang: PropTypes.object,
    index: PropTypes.number,
    openPropertyDetails: PropTypes.func,
};

export default MultipropertyCard;
